import { AlertTriangle } from 'lucide-react';

export function RupturaBadge() {
  return (
    <span className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded border bg-red-100 text-red-800 border-red-200">
      <AlertTriangle className="w-3 h-3" />
      Ruptura
    </span>
  );
}
